import { Reducer, combineReducers } from 'redux';
import { reducer as oidc, UserState } from 'redux-oidc';

import { reducer as app } from '../App';
import { AppState } from '../App/state/reducer';

export interface RootState {
  oidc: UserState;
  app: AppState;
}

const rootReducer: Reducer<RootState> = combineReducers({
  oidc,
  app,
});

export default rootReducer;
